export default {
  headers: {
    edit_time: 'Edit time',
    create_time: 'Create time',
  },
  labels: {
    select_all: 'Select all',
  },
  buttons: {
    add_opening_time: 'Add opening time',
    add: 'Add',
    cancel: 'Cancel',
  },
};
